<template>
  <div class="container m-t-4 m-b-3">
    <p class="h5 m-b-3">Here's what happens next:</p>
    <div class="layout gap-4">
      <template v-for="step in $options.NEXT_STEPS">
        <div :key="step.number" class="layout-item is-12 is-4:t">
          <div class="d-flex ai-center fd-column:t">
            <vk-icon :name="step.icon" class="c-green flex-1-0" size="50"/>
            <div class="w-100">
              <div class="d-flex m-l-2:mo ai-baseline">
                <span class="d-none:mo h3 m-r-1 text-bold">{{ step.number }}.</span>
                <div class="m-t-2:t" :selenium="`next-steps:${step.number}`">{{ step.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const NEXT_STEPS = [
  {
    number: 1,
    icon: 'phone-call',
    text: 'You will be contacted by one or more pros in the next 24-48 hours.',
  },
  {
    number: 2,
    icon: 'chat-bubbles',
    text: 'Discuss the details of your project with them.',
  },
  {
    number: 3,
    icon: 'pro',
    text: 'Select the pro who\'s right for your job and budget.',
  },
];

export default {
  name: 'next-steps',
  NEXT_STEPS,
};
</script>
